import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ReactComponent as CheckIcon } from '../../assets/images/icons/check.svg';
import Button from '../../components/Button';
import WebViewAppBar from '../../components/WebViewAppBar/WebViewAppBar';
import HideChatWidget from '../../components/ZendeskChat/HideChatWidget';
import styles from './UpdateBillingInfo.module.scss';
import { HideCookieConsentBanner } from '../../lib/oneTrust';

interface UpdateBillingInfoConfirmationState {
  message: string;
}
export function UpdateBillingInfoConfirmation() {
  const { t } = useTranslation();
  const location = useLocation<UpdateBillingInfoConfirmationState>();
  const successMessage = location.state?.message ?? null;

  return (
    <>
      <div className={styles.confirmationContainer}>
        <WebViewAppBar className={styles.mobileOnly} title={t('update_payment_information')} />
        <div className={styles.section}>
          <div className={styles.checkIcon}>
            <CheckIcon width="64px" height="64px" />
          </div>
          <h2>{t('success')}</h2>
          <p>{successMessage || t('your_fi_membership_is_now_active')}</p>
        </div>
        <div className={classNames(styles.actions, styles.mobileOnly)}>
          <Button onClick={() => window.open('fi://closeappview')}>{t('done')}</Button>
          <div className={styles.buttonSpacer} />
        </div>
        <HideChatWidget />
        <HideCookieConsentBanner />
      </div>
    </>
  );
}
